import { trackingPageOrderSchema } from "@redotech/order-tracking-common/tracking-page-order-definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getTrackingPageOrder = {
  name: "getTrackingPageOrder" as const,
  input: z.object({ orderId: zExt.objectId() }),
  output: z.object({
    trackingPageOrder: trackingPageOrderSchema.nullable(),
    jsMapsApiEnabled: z.boolean(),
  }),
};
